export enum AddCardResults {
    ADDED = "ADDED",
    CAP_REACHED = "CAP_REACHED",
    // Bulk add only: some cards were added before the cap was reached.
    INCOMPLETE_ADD = "INCOMPLETE_ADD",
    PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
}
